// extracted by mini-css-extract-plugin
module.exports = {"brandCard":"styles_brandCard__0k57O","brandCardImage":"styles_brandCardImage__c0Ce9","contactUs":"styles_contactUs__wgc_G","tcs":"styles_tcs__qThDE"};